window.addEventListener('DOMContentLoaded', () => {

	/**
	 * Configure speechable elements
	 */
	const elements = [
		{
			tag: 'a',
			triggers: ['focus','mouseover'],
			text: 'innerText',
			template: 'Ga naar [text]'
		},
		{
			tag: '.twz-element-text',
			triggers: ['click','focus'],
			text: 'innerText',
			template: '[text]'
		},
		{
			tag: 'span',
			triggers: ['focus','mouseover'],
			text: 'innerText',
			template: '[text]'
		},
	];



	/**
	 * Setup
	 */
	const textToSpeechButton = document.querySelector('[data-accessibility="text-to-speech"]');
	const ttsEnabledText = 'Voorleesfunctie: ingeschakeld. Klik op een element om deze voorte laaten lezen';
	const ttsDisabledText = 'Voorleesfunctie: uitgeschakeld.';
	const voice = "Dutch Male";

	const textToSpeech = (event) => {
		
		if( document.body.classList.contains('text-to-speech')) {

			//Add class to all speechable items
			event.currentTarget.classList.add('is-speechable');
			const target = event.target

			if(target.classList.contains('text--is-selected') ) {
				responsiveVoice.cancel();
				target.classList.remove('text--is-selected');
			} else {
				target.classList.add('text--is-selected');
				const match = elements.filter(element => element.triggers.includes(event.type) && event.target.matches(element.tag) ).shift();
				responsiveVoice.speak( match.template.replace('[text]',event.currentTarget[match.text]), voice)
			}
			
			/**
			 * Polling to stop speech automatically after playing is over
			 */
			let player = setInterval( () => {

				if(!responsiveVoice.isPlaying()) {
					target.classList.remove('text--is-selected');
					clearInterval(player);
				}
			}, 200);

		} else {
			e.classList.remove('is-speechable');
		}

	}

	/**
	 * Text to Speech enable/disable
	 */
	const setStatus = (textToSpeechActive) => {

		//@todo Data-speech attribute
		if( textToSpeechActive ) 
			elements.forEach(element => document.querySelectorAll(`${element.tag}`).forEach(e => [...element.triggers].forEach(trigger => e.addEventListener(trigger, textToSpeech, false ))))
		else
			elements.forEach(element => document.querySelectorAll(`${element.tag}`).forEach(e => [...element.triggers].forEach(trigger => e.removeEventListener(trigger, textToSpeech))))			
	}


	/**
	 * Init
	 */
	if( typeof( responsiveVoice ) !== 'undefined' && textToSpeechButton ) {
 
		let textToSpeechActive = document.body.classList.contains('text-to-speech');
		setStatus(textToSpeechActive);

		textToSpeechButton.addEventListener('click', e => {
			textToSpeechActive = !textToSpeechActive;
			setStatus(textToSpeechActive);
			responsiveVoice.speak(textToSpeechActive ? ttsEnabledText : ttsDisabledText, voice);
		})
		
	}

})